import React from 'react';
import * as PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { SimpleDropDownElement } from 'components/simple-dropdown/index';
import { homePageStartVideoSelector } from 'common/selectors/index';
import { isAdminUser } from 'utils/index';
import { withRouter } from 'react-router-dom';
import { unmarkHomeStartVideoAction, markHomeStartVideoAction } from './actions';

const mapStateToProps = (state) => ({
  homeStartVideoId: homePageStartVideoSelector(state),
});

const mapDispatchToProps = (dispatch, props) => ({
  unMarkAsHomeStartVideo: () => {
    dispatch(unmarkHomeStartVideoAction(props.video));
  },
  markAsHomeStartVideo: () => {
    dispatch(markHomeStartVideoAction(props.video));
  },
});

const MarkUnmarkStartHomeVideo = ({ video, t, unMarkAsHomeStartVideo, markAsHomeStartVideo, homeStartVideoId }) => {
  if (!isAdminUser()) {
    return false;
  }

  const isStart = video.id === homeStartVideoId;

  return (
    <SimpleDropDownElement
      data-e2e="mark-as-start-homevideo-dropdown"
      onClick={isStart ? unMarkAsHomeStartVideo : markAsHomeStartVideo}
    >
      {isStart ? t('unmark_home_start_video') : t('mark_home_start_video')}
    </SimpleDropDownElement>
  );
};

export const MarkUnmarkStartHomeVideoDecorated = compose(
  withTranslation(),
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(MarkUnmarkStartHomeVideo);

MarkUnmarkStartHomeVideoDecorated.propTypes = {
  video: PropTypes.object.isRequired,
};

export * from './actions';
export * from './effects';
